<script>
import { mapActions, mapGetters } from 'vuex';

import DepositReturnModal from '@/components/deposits/DepositReturnModal.vue';
import ModalFormContract from '@/components/contracts_new/ModaFormComponent.vue';
import Catalogue from '@/services/catalogue';
import request from '@/services/request';

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

import Pagination from 'vue-pagination-2';


export default {
    name: "departaments-table",
    components: {
        DatePicker,
        Pagination,
        ModalFormContract,
        DepositReturnModal
    },
    data() {
        return {
            departments: [],
            search: {
                search: '',
                date: '',
                building_id: '',
                department_id: '',
            },
            increases: [],
            searchAll: '',
            page: 1,
            load: false,
            catalogue: new Catalogue(),
        }
    },
    methods: {
        openDepositReturn(row) {

            Event.$emit('open-deposit-return-modal', row);

            // EventBus.$emit('open-deposit-return-modal', {
            //     contract_due_item_id: row.id
            // });
        },
        pay(item) {
            console.log(item);
            this.$swal({
                title: 'Marcar como pagado',
                text: '¿ Seguro que quiere marcar como pagado ?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Pagar',
                cancelButtonText: 'Cancelar'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    this.send = true;
                    let _endpoint = '/pay_deposit';
                    let data_form = new FormData();
                    data_form.append('id', JSON.stringify(item.id));

                    try {
                        let { data } = await request.post(_endpoint, data_form)
                        if (data) {
                            console.log(data);
                            this.successNotification(data.message);
                            this.list();
                        }
                    } catch (error) {
                        this.errors = {};
                        if (error.response) {
                            this.errors = await this.errorNotification(error);
                        }
                    }
                }
            });
            // Event.$emit('event-show-addPays', item);
        },
        async downloadFile(id) {
            let url = `${this.globalUrlFiles}/api/voucher_deposit?id=${id}`;
            window.open(url, '_blank');
        },
        showContract(id) {
            Event.$emit('event-show-showContractID', id);
        },
        async list() {
            this.load = true;
            let service = request;
            let search = {};
            search.search = this.searchAll;
            search.building_id = this.search.building_id;
            search.department_id = this.search.department_id;
            search.date = this.search.date;

            let _endpoint = '/contracts_all_deposit';
            try {
                let { data } = await service.get(_endpoint, search)
                if (data) {
                    this.departments = data;
                    this.load = false;
                }
            } catch (error) {
                console.log(error);
                this.load = false;
            }
        },
        ...mapActions({
            resetPassword: 'auth/resetPass',
            errorNotification: 'alert/error',
            successNotification: 'alert/success',
        }),
    },
    mounted() {
        this.list();
        this.catalogue.get_buildings();
    },
    created() {
        Event.$on("event-load-departaments", () => {

        });
    },
    computed: {
        ...mapGetters({
            'authUser': 'auth/user'
        })
    },
    watch: {
        'search': {
            handler: function () {
                this.list();
            },
            deep: true
        },
    }
}
</script>
<template>
    <div class="col-12">
        <div class="card card-outline">
            <div class="card-header">
                <h3 class="card-title">Lista de Depósitos</h3>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-md-6">
                        <label>Fecha :</label>
                        <date-picker format="YYYY-MM" valueType="format" type="month" :clearable="false"
                            v-model="search.date"></date-picker>
                    </div>
                    <div class="col-md-6">
                        <label>Propiedad :</label>
                        <select class="form-control" v-model="search.building_id" @change="list()">
                            <option value="">Todas</option>
                            <option :value="building.id" v-for="(building, index) in catalogue.buildings" :key="index">
                                {{ building.name }}
                            </option>
                        </select>
                    </div>
                </div>

                <br>

                <div class="table-responsive">
                    <table class="table table-bordered text-center text-sm">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Propiedad</th>
                                <th>Indiviso</th>
                                <th>Depósito</th>
                                <th>Arrendatario</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody v-if="load">
                            <tr>
                                <td align="center" colspan="5">
                                    <i class="fa-solid fa-circle-notch fa-spin fa-3x mb-1"></i>
                                    <h5>Cargando</h5>
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else-if="departments.data.length > 0">
                            <tr v-for="(departament, index) in departments.data" :key="index">
                                <td>
                                    {{ departament.id }}
                                    <span v-if="departament.pay" class="badge badge-success"><i
                                            class="fa-solid fa-check"></i> Pagado </span>
                                </td>
                                <td>
                                    <span v-if="departament.contract_due.contract.building">
                                        {{ departament.contract_due.contract.building.name }}
                                    </span>
                                    <span v-else>
                                        Sin Propiedad
                                    </span>
                                </td>
                                <td>
                                    <span v-show="departament.contract_due.contract.contract_departments.length > 0"
                                        v-for="(departamento, index) in departament.contract_due.contract.contract_departments"
                                        :key="index">
                                        <span v-if="departamento.department">
                                            {{ departamento.department.number }} / {{ departamento.department.level }}
                                        </span>
                                        <br>
                                    </span>
                                    <span v-if="departament.contract_due.contract.contract_departments.length == 0">
                                        Sin departamentos
                                    </span>
                                </td>
                                <td>
                                    {{ departament.contract_due.due_date | toDateTime }}
                                    <hr>
                                    {{ departament.final_amount | toCurrency }}
                                </td>
                                <td>
                                    <span v-if="departament.contract_due.contract.user">
                                        {{ departament.contract_due.contract.user.name }}
                                        {{ departament.contract_due.contract.user.last_name }}
                                    </span>
                                    <span v-else>
                                        Sin Propiedad
                                    </span>

                                </td>
                                <td>
                                    <button type="button" v-if="departament.contract_due.contract"
                                        class="m-1 btn btn-outline-primary btn-sm"
                                        @click="showContract(departament.contract_due.contract.id)">
                                        <i class="fa-solid fa-file-lines fa-fw"></i> Ver contrato
                                    </button>
                                    
                                    <a type="button" target="_blank" class="m-1 btn btn-outline-secondary btn-sm"
                                        :href="`${globalUrlFiles}/api/voucher_deposit?id=${departament.id}`">
                                        <i class="fa-solid fa-file-lines fa-fw"></i> Recibo deposito
                                    </a>

                                    <button type="button" @click="pay(departament)" v-if="!departament.pay"
                                        class="m-1 btn btn-outline-success btn-sm">
                                        <i class="fa-solid fa-wallet"></i> Pagar
                                    </button>

                                    <button type="button" class="btn btn-sm btn-outline-success" 
                                        @click="openDepositReturn(departament)" v-if="departament.pay">
                                        <i class="fas fa-undo-alt"></i>
                                        Regresar depósito
                                    </button>

                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td align="center" colspan="5">Sin resultados.</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <pagination v-if="departments" v-model="page" :records="departments.total"
                    :per-page="departments.per_page" @paginate="list" />
            </div>

        </div>
        <ModalFormContract :prop_edit="false" />
        <DepositReturnModal />
    </div>
</template>